import { render, staticRenderFns } from "./Slippage.vue?vue&type=template&id=e837c7e2&"
import script from "./Slippage.vue?vue&type=script&lang=js&"
export * from "./Slippage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports